<template>
	<div class="gc-container">
		<div class="background-images">
			<img :src="wpOptions.bg" class="right">
			<img :src="wpOptions.bg" class="left">
		</div>
		<div class="container">
			<img :src="wpOptions.image" alt="כרמלה גיפט קארד" class="hero">
			<h2 class="title ff-raanan">{{userLoggedInfo.firstname}}, {{wpOptions.title}}</h2>
			<button class="cta" :class="{loading: !cards}" @click="downloadPDFs">
				<img class="gc-loader" :src="wpData.assets_url + '/svg/loader.svg'" alt="">
				<img class="icon" :src="wpData.assets_url + '/svg/gc-download.svg'" alt="להורדת גיפט קארדים">
				<span class="text">{{wpOptions.button_text}}</span>
			</button>
			<p class="legal">{{wpOptions.legal}}</p>
		</div>
	</div>
</template>

<script>

	export default {

		name: 'ThankYou',
		metaInfo: {
			title: wpData.globalOptions.gc_page_purchase.seo_title,
			meta: [{
				name: 'description',
				content: wpData.globalOptions.gc_page_purchase.seo_desc
			}]
		},
		data () {
			return {
				wpData: wpData,
				wpOptions: wpData.globalOptions.gc_page_thank_you,
				cards: false,
				userLoggedInfo: this.$store.state.userLoggedInfo
			}
		},
		props: [ 'orderId', 'orderKey' ],
		watch: {
			
		},
		methods: {
			downloadPDFs(){
				let url = '';
				if ( this.cards.length === 1 ) {
					url = this.wpData.home_url + '/?view_gift_card=' + this.cards[0] + '&order_id=' + this.orderId + '&order_key=' + this.orderKey;
				} else {
					url = this.wpData.home_url + '/?view_gift_card_zip=1&order_id=' + this.orderId + '&order_key=' + this.orderKey;
				}
				window.open(url);
			}
		},
		computed: {
			
		},
		mounted(){

			/* FOR DEBUGGING */
			// this.$set( this.$store.state, 'giftCardPurchaseSelectedCards', [{"title":"כרטיס מגניב של מאה שקל","desc":"לורם איפסום דולור סיט אמת וזה וזה ועוד טקסט","cash_value":"1","image":"http://localhost/bitbucket/carmella/wp-content/uploads/2021/08/card-1@3x.png","quantity":1,"restored":false,"send_details":{"method":"their_mail","name":"ראשון של מאה","email":"somemail1@one.com","phone":"","message":"הדקשנה וזה וזה"}},{"title":"כרטיס מגניב של מאה שקל","desc":"לורם איפסום דולור סיט אמת וזה וזה ועוד טקסט","cash_value":"1","image":"http://localhost/bitbucket/carmella/wp-content/uploads/2021/08/card-1@3x.png","quantity":1,"restored":false,"send_details":{"method":"sms","name":"שני של מאה","email":"","phone":"0543162916","message":""}},{"title":"גיפט קארד מגניב בינוני","desc":"רמת מגניבות בינונית בהחלט","cash_value":"2","image":"http://localhost/bitbucket/carmella/wp-content/uploads/2021/08/card-2@3x.png","quantity":1,"restored":false,"send_details":{"method":"my_mail","name":"ראשון של  מאתיים","email":"","phone":"","message":""}}] );
			// this.$set( this, 'cards', [{"title":"כרטיס מגניב של מאה שקל","desc":"לורם איפסום דולור סיט אמת וזה וזה ועוד טקסט","cash_value":"1","image":"http://localhost/bitbucket/carmella/wp-content/uploads/2021/08/card-1@3x.png","quantity":2},{"title":"גיפט קארד מגניב בינוני","desc":"רמת מגניבות בינונית בהחלט","cash_value":"2","image":"http://localhost/bitbucket/carmella/wp-content/uploads/2021/08/card-2@3x.png","quantity":1},{"title":"סתם שם שךא מוצג בכלל","desc":"כמעט הכי מגניב שווה לנסות","cash_value":"3","image":"http://localhost/bitbucket/carmella/wp-content/uploads/2021/08/card-1@3x.png","quantity":0},{"title":"לא מוצג","desc":"הכי הכי שווה והכי הכי מגניב","cash_value":"4","image":"http://localhost/bitbucket/carmella/wp-content/uploads/2021/08/card-2@3x.png","quantity":0}] );
			/* END DEBUGGING */

			// Get cards data
			fetch( this.wpData.ajax_url + '?action=cgc_getOrderCardIDs&orderID=' + this.orderId )
				.then( raw => raw.json() )
					.then( r => {
						if ( r.success ) {
							this.cards = r.data.cardIDs;
						}
					});

		},
		components: {
			
		}
	}
</script>

<style lang="sass" scoped>

	@import '../../assets/sass/gift-card-abstracts.sass'

	.background-images
		position: relative
		z-index: 1
		img
			position: fixed
			bottom: 0
			right: 0
			height: 25vw
			+mobile
				height: auto
				width: 100%
				bottom: -20vw
				opacity: 0.7
		.left
			right: auto
			left: 0
			transform: rotateY(180deg)
			+mobile
				display: none


	.container
		text-align: center
		width: 30rem
		padding: 2rem 0
		position: relative
		z-index: 2
		+mobile
			width: 100%
			padding: 2rem 1rem

	img.hero
		margin: 0 auto
		width: 100%
		+mobile
			width: 75%
			margin-bottom: -1rem

	.title
		padding: 0 2rem
		line-height: 0.9

	button.cta.loading
		pointer-events: none
		.icon, .text
			opacity: 0
		.gc-loader
			display: block
			position: absolute
			top: 50%
			left: 50%
			transform: translate(-50%, -50%)
			margin: 0
			height: 2rem

	button.cta
		pointer-events: all
		font-size: 1.25rem
		background: $main
		color: $white
		border: none
		outline: none
		padding: 1rem 1.5rem 1rem 2rem
		border-radius: 5rem
		margin: 1rem 0 0 0
		position: relative
		white-space: nowrap
		+mobile
			width: 100%
		&:hover, &:focus
			background-color: lighten($main, 4%)
		&:active
			background-color: lighten($main, 7%)

		span, img
			display: inline-block
			color: $white
		img
			height: 1rem
			margin-left: 0.75rem
		.gc-loader
			display: none

	.legal
		margin-top: 3rem
		font-size: 1rem
		line-height: 1.5
		color: lighten($black, 30%)

</style>